import { render, staticRenderFns } from "./ListingOwnersHistory.vue?vue&type=template&id=dc9ffcc4&scoped=true"
import script from "./ListingOwnersHistory.vue?vue&type=script&lang=js"
export * from "./ListingOwnersHistory.vue?vue&type=script&lang=js"
import style0 from "./ListingOwnersHistory.vue?vue&type=style&index=0&id=dc9ffcc4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc9ffcc4",
  null
  
)

export default component.exports